import { useState } from 'react';
import type { User, CreateUserRequest } from '../../schemas/validation';
import type { UserFilterOption } from './utils';

export interface AdminDashboardState {
  users: User[];
  setUsers: React.Dispatch<React.SetStateAction<User[]>>;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  filterRole: UserFilterOption;
  setFilterRole: (role: UserFilterOption) => void;
  showCreateForm: boolean;
  setShowCreateForm: (show: boolean) => void;
  editingUser: User | null;
  setEditingUser: (user: User | null) => void;
  isSubmitting: boolean;
  setIsSubmitting: (submitting: boolean) => void;
  showDeleteModal: boolean;
  setShowDeleteModal: (show: boolean) => void;
  userToDelete: User | null;
  setUserToDelete: (user: User | null) => void;
  showToggleAdminModal: boolean;
  setShowToggleAdminModal: (show: boolean) => void;
  userToToggleAdmin: User | null;
  setUserToToggleAdmin: (user: User | null) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  usersPerPage: number;
  subscriptionStats: any;
  setSubscriptionStats: (stats: any) => void;
  mimicingUserId: string | null;
  setMimicingUserId: (id: string | null) => void;
  formData: CreateUserRequest;
  setFormData: React.Dispatch<React.SetStateAction<CreateUserRequest>>;
}

export const useAdminDashboardState = (): AdminDashboardState => {
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRole, setFilterRole] = useState<UserFilterOption>('all');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editingUser, setEditingUser] = useState<User | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState<User | null>(null);
  const [showToggleAdminModal, setShowToggleAdminModal] = useState(false);
  const [userToToggleAdmin, setUserToToggleAdmin] = useState<User | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);
  const [subscriptionStats, setSubscriptionStats] = useState<any>(null);
  const [mimicingUserId, setMimicingUserId] = useState<string | null>(null);
  const [formData, setFormData] = useState<CreateUserRequest>({
    name: '',
    email: '',
    password: '',
    isAdmin: false,
    emailVerified: false,
  });

  return {
    users,
    setUsers,
    isLoading,
    setIsLoading,
    searchTerm,
    setSearchTerm,
    filterRole,
    setFilterRole,
    showCreateForm,
    setShowCreateForm,
    editingUser,
    setEditingUser,
    isSubmitting,
    setIsSubmitting,
    showDeleteModal,
    setShowDeleteModal,
    userToDelete,
    setUserToDelete,
    showToggleAdminModal,
    setShowToggleAdminModal,
    userToToggleAdmin,
    setUserToToggleAdmin,
    currentPage,
    setCurrentPage,
    usersPerPage,
    subscriptionStats,
    setSubscriptionStats,
    mimicingUserId,
    setMimicingUserId,
    formData,
    setFormData,
  };
};
